const apiClient = require('@/api/client.js')

export default {

  send(onboard, callback){

    if (!onboard.wmcUser){
      return callback(new Error('Please enter your WMC user name'))
    }

    if (!onboard.wmcAdmin) {
      return callback(new Error('Please enter your WMC admin user name'))
    }

    if (!onboard.wmcAdminPass) {
      return callback(new Error('Please enter your WMC admin password'))
    }

    if (!onboard.dispatchDomain) {

      return callback(new Error('Please enter your dispatch domain'))
    }

    if (!onboard.treezAPIKey) {
      return callback(new Error('Please enter your Treez API key'))
    }

    if (!onboard.treezDispensaryName) {
      return callback(new Error('Please enter your Treez dispensary name'))
    }

    if (onboard.metrc) {
      if (!onboard.recreationLicense) {
        return callback(new Error('Please enter your recreation license'))
      }

      if (!onboard.medicalLicense) {
        return callback(new Error('Please enter your medical license'))
      }

      if (!onboard.metrcState) {
        return callback(new Error('Please enter your metrc state'))
      }

      if (!onboard.metrcClientKey) {
        return callback(new Error('Please enter your metrc client key'))
      }
    }

    // This is LD website API key
    return apiClient.makeRequest('POST', '/company/onboard', onboard, {'x-api-key': '899deca0ca2e6763d8068c756a8f575d'}, callback);

  }

}



// WEBPACK FOOTER //
// ./src/components/onboard/service.js